import React, { useState } from "react";
import FilterReportDateItens from "../../../components/filter/reportDateItens/filter";
import reqNotaFiscal from "../../../services/reqCobranca/reqNotaFiscal";
import Notification from "../../../components/toast";
import MainReportMatrix from "../../report/matrix";

const ReportNotaFiscal = () => {
	const [gaps, setGaps] = useState([]);

	const options = {
		title: "Gestão Fiscal",
		subTitle: "Auditoria, histórico e espelho de Notas Fiscais emitidas (NF-e e NFC-e)",
		ident: "listagemNFeNFCe",
		identFilter: "filterNFeNFCe",
		identReport: "reportNFeNFCe",
		tableColumns: [
			{ key: "modelo", label: "Modelo", align: "center", width: "80px" },
			{ key: "numero", label: "Número", align: "center", width: "100px" },
			{ key: "cliente", label: "Cliente", align: "center" },
			{ key: "valor_total", label: "Valor", align: "center", format: "currency" },
			{ key: "data_emissao", label: "Emissão", align: "center", format: "dateTime" },
			{ key: "status", label: "Status", align: "center" },
			{ key: "motivo", label: "Motivo / Retorno", align: "left" },
		],
		reportColumns: [
			{ key: "modelo", label: "Modelo", align: "center", visible: true },
			{ key: "numero", label: "Número", align: "center", visible: true },
			{ key: "cliente", label: "Cliente", align: "center", visible: true },
			{ key: "valor_total", label: "Valor", align: "center", format: "currency", visible: true },
			{ key: "status", label: "Status", align: "center", visible: true },
		],
		showTime: true,
		hasActive: true,
		activeLabel: { true: "Todas as Notas", false: "Somente Rejeições" },
		hasSaleType: false,
		hasParam: true,
		parametersDate: [{ id: 1, label: "Dt. Emissão", value: "dtEmissao" }],
		parametersFilter: [
			{ id: 1, label: "Cliente", value: "cliente" },
			{ id: 2, label: "Número NF", value: "numeroNf" },
		],
	};

	const checkGaps = (notas) => {
		// Separa por modelo para não misturar NF-e (55) com NFC-e (65)
		const notas55 = notas.filter(n => n.modelo === 55).map(n => n.numero).sort((a,b) => a - b);
		const notas65 = notas.filter(n => n.modelo === 65).map(n => n.numero).sort((a,b) => a - b);
		
		let falhas = [];

		const findGaps = (arr, modelo) => {
			if (arr.length === 0) return;
			for (let i = 0; i < arr.length - 1; i++) {
				if (arr[i+1] - arr[i] > 1) {
					for (let j = arr[i] + 1; j < arr[i+1]; j++) {
						falhas.push({ modelo, numero: j });
					}
				}
			}
		};

		findGaps(notas55, 55);
		findGaps(notas65, 65);

		setGaps(falhas);
	};

	const fetch = async (filterData, newPage = 1, perPage = 15) => {
		try {
			// Tratamento do status (No ReportMatrix, Ativo = true por padrão)
			let statusFilter = "";
			if (filterData.active === 'false' || filterData.active === false) {
				statusFilter = "PENDENTE";
			}

			const newFilterData = { ...filterData, page: newPage, perPage, status: statusFilter };
			const res = await reqNotaFiscal.listRelatorio(newFilterData);
			let allData = res.data || [];

			// Auditoria fiscal (gap check) apenas se não for filtro de erros
			if (statusFilter !== "PENDENTE") {
				checkGaps(allData);
			} else {
				setGaps([]);
			}

			// Filtros Textuais
			if (filterData.param?.value && filterData.paramValue) {
				const termo = filterData.paramValue.toLowerCase();
				if (filterData.param.value === "cliente") {
					allData = allData.filter(n => n.cliente && n.cliente.toLowerCase().includes(termo));
				} else if (filterData.param.value === "numeroNf") {
					allData = allData.filter(n => n.numero.toString() === termo);
				}
			}

			// Ordenação (Mais recentes no topo da tabela)
			allData.sort((a, b) => b.numero - a.numero);

			// Paginação Simulada (O Matrix exige esse formato)
			const offset = (newPage - 1) * perPage;
			const paginatedItems = allData.slice(offset, offset + perPage);

			return { data: paginatedItems };
		} catch (error) {
			console.error("Erro ao buscar notas", error);
			Notification.showToast({ message: "Erro ao buscar notas fiscais.", type: "error" });
			return { data: [] };
		}
	};
	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)] relative">
			<MainReportMatrix
				options={options}
				fetch={fetch}
				FormFilter={FilterReportDateItens}
			/>

			{gaps.length > 0 && (
				<div className="fixed bottom-6 right-6 z-50 bg-white border-l-4 border-red-500 p-4 rounded-lg shadow-2xl max-w-md animate-bounce-short">
					<h3 className="text-red-800 font-bold text-lg flex items-center gap-2">
						⚠️ Alerta de Sequência
					</h3>
					<p className="text-gray-700 text-sm mt-1 leading-tight">
						Buracos na numeração detectados! De acordo com a Sefaz, eles devem ser inutilizados:
					</p>
					<div className="mt-3 flex flex-wrap gap-1 max-h-32 overflow-y-auto">
						{gaps.map((g, i) => (
							<span key={i} className="bg-red-50 text-red-700 px-2 py-1 rounded text-xs font-bold border border-red-100">
								{g.modelo === 65 ? 'NFC-e' : 'NF-e'} nº {g.numero}
							</span>
						))}
					</div>
				</div>
			)}
		</div>
	);
};

export default ReportNotaFiscal;
